<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <v-toolbar flat class="toolbar" dense justify="center">
                <v-toolbar-title align="center">
                    <strong>
                        Admitted Student Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center">
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="field.org" :items="org_list" item-text="name" return-object label="Organization" outlined @click="clear()" @change="getAy()"></v-autocomplete>
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="field.std_id" :items="standard_list" item-text="standard" item-value="standard" label="Standard" @click="clear()" outlined @change="getStandard();"></v-autocomplete>
                </v-col>
                <v-col sm="2" v-if="field.std_id!=''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="field.div" :items="dision_list" item-text="div_name" item-value="div_name" label="Division" @click="clear()" outlined></v-autocomplete>
                </v-col>
                <v-col sm="2" v-if="field.div">
                    <v-btn rounded class="button mt-6" @click="getAllReport();" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12">
                <v-row justify="center" dense>
                    <v-col sm="2">
                        <v-switch color="#0F2027" v-model="all_toggle" label="Toggle All"></v-switch>
                    </v-col>
                </v-row>
                <v-row justify="space-around">
                    <v-switch color="#0F2027" v-model="field.admission_form_no" label="Admission Form No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.registration_number" label="Registration Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.rollno" label="Roll No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.grno" label="GRNo"></v-switch>
                    <v-switch color="#0F2027" v-model="field.quota" label="Quota"></v-switch>
                    <v-switch color="#0F2027" v-model="field.saralid" label="Saral-id"></v-switch>
                    <v-switch color="#0F2027" v-model="field.admissionyear" label="Admission Year"></v-switch>
                    <v-switch color="#0F2027" v-model="field.admission_date" label="Admission Date"></v-switch>
                    <v-switch color="#0F2027" v-model="field.admissionstatus" label="Admission Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.firstname" label="First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.middlename" label="Middle Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.lastname" label="Last Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.fullname" label="Full Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_full_name" label="Father Full Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_first_name" label="Mother First Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth" label="DoB"></v-switch>
                    <v-switch color="#0F2027" v-model="field.date_of_birth_in_words" label="Date Of Birth In Words"></v-switch>
                    <v-switch color="#0F2027" v-model="field.family_income" label="Family Income"></v-switch>
                    <v-switch color="#0F2027" v-model="field.division" label="Division"></v-switch>
                    <v-switch color="#0F2027" v-model="field.standard" label="Standard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.currentstandard" label="Current Standard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.house" label="House"></v-switch>
                    <v-switch color="#0F2027" v-model="field.bloodgroup" label="Blood Group"></v-switch>
                    <v-switch color="#0F2027" v-model="field.category" label="Category"></v-switch>
                    <v-switch color="#0F2027" v-model="field.religion" label="Religion"></v-switch>
                    <v-switch color="#0F2027" v-model="field.cast" label="Caste"></v-switch>
                    <v-switch color="#0F2027" v-model="field.aadhar_no" label="Aadhar No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.domacile" label="Domicile"></v-switch>
                    <v-switch color="#0F2027" v-model="field.prizes" label="Prizes"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previous_school_name" label="Previous School Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previousschoolpassingstandard" label="Previous School Passing Standard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previousschoollastyear" label="Previous School Last Year"></v-switch>
                    <v-switch color="#0F2027" v-model="field.previousschoolschoolboard" label="Previous School SchoolBoard"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mobile_no" label="Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.alternate_mobile_no" label="Alternate Mobile No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.telephone_no" label="Telephone No"></v-switch>
                    <v-switch color="#0F2027" v-model="field.primary_contact_number" label="Primary No.(communication purpose)"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_contact_number" label="Father's Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_contact_number" label="Mother's Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_number" label="Emergency Contact Number"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_name" label="Emergency Contact Name"></v-switch>
                    <v-switch color="#0F2027" v-model="field.emergency_contact_address" label="Emergency Contact Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_place" label="Birth Place"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_address" label="Birth Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.physicallyhandicapped_details" label="Physically Handicapped Details"></v-switch>
                    <v-switch color="#0F2027" v-model="field.isphysicallyhandicapped" label="Is physically Handicapped"></v-switch>
                    <!-- <v-switch color="#0F2027" v-model="field.highest_qualification" label="Highest Qualification"></v-switch> -->
                    <v-switch color="#0F2027" v-model="field.personal_email" label="Personal Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.institute_email" label="Institute Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.home_distance_in_km_from_school" label="Home Distance In Km From School"></v-switch>
                    <v-switch color="#0F2027" v-model="field.gender" label="Gender"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birthcountry" label="Birth Country"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mothertoungue" label="Mother Tongue"></v-switch>
                    <v-switch color="#0F2027" v-model="field.localaddress" label="Local Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.permanentaddress" label="Permanent Address"></v-switch>
                    <v-switch color="#0F2027" v-model="field.photo" label="Student Photo Status"></v-switch>
                    <v-switch color="#0F2027" v-model="field.father_email" label="Father's Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.mother_email" label="Mother's Email"></v-switch>
                    <v-switch color="#0F2027" v-model="field.sibling_details" label="Siblings Details"></v-switch>
                    <v-switch color="#0F2027" v-model="field.birth_mark" label="Birth Mark"></v-switch>
                    <v-switch color="#0F2027" v-model="field.medical_condition" label="Medical Condition"></v-switch>
                    <v-switch color="#0F2027" v-model="field.allergy" label="Allergy"></v-switch>
                </v-row>
            </v-col>
            <div v-if="org_data_list!=''">
                <v-btn rounded color="success" outlined @click="ExportToExcel();" :loading="exs_loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
                <div id="my-table-id">
                    <div class="scroll">
                        <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                            <thead>
                                <tr>
                                    <th v-for="(hl, index) in header_list" :key="index">
                                        {{ hl.text }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="(fl, index) in org_data_list" :key="index">
                                    <td v-for="(hl, index1) in header_list" :key="index1">{{fl[hl.value]}}</td>
                                </tr>
                            </tbody>
                            <!-- <tfoot>
                            <tr>
                                <th v-for="(hl, index) in header_list" :key="index">
                                    {{ hl.text }}
                                </th>
                            </tr>
                        </tfoot> -->
                        </v-simple-table>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                all_toggle: false,
                loader: false,
                overlay: false,
                color: "",
                snackbar: false,
                search: null,
                snackbar_msg: null,
                fees_structure_data: null,
                current_academic_year: null,
                stream: null,
                header: null,
                standard_list: null,
                dision_list: null,
                org_list: null,
                display_data: false,
                org_data_list: [],
                division_list: [],
                dialog: false,
                org_data: [],
                fetch_loader: false,

                field: {
                    father_email:false,
                mother_email:false,
                sibling_details:false,
                birth_mark:false,
                medical_condition:false,
                allergy:false,
                division:false,
                admission_form_no: false,
                firstname: false,
                middlename: false,
                lastname: false,
                fullname: false,
                date_of_birth: false,
                standard: false,
                bloodgroup: false,
                category: false,
                religion: false,
                aadhar_no: false,
                mobile_no: false,
                alternate_mobile_no: false,
                telephone_no: false,
                emergency_contact_name: false,
                emergency_contact_address: false,
                emergency_contact_number: false,
                mother_contact_number: false,
                father_contact_number: false,
                primary_contact_number: false,
                birth_place: false,
                birth_address: false,
                father_full_name: false,
                mother_first_name: false,
                physicallyhandicapped_details: false,
                isphysicallyhandicapped: false,
                date_of_birth_in_words: false,
                highest_qualification: false,
                personal_email: false,
                institute_email: false,
                home_distance_in_km_from_school: false,
                gender: false,
                birthcountry: false,
                mothertoungue: false,
                // current_academic_year: false,
                admissionyear: false,
                previous_school_name: false,
                prizes: false,
                rollno: false,
                family_income: false,
                admission_date: false,
                registration_number: false,
                admissionstatus: false,
                domacile: false,
                cast: false,
                previousschoolpassingstandard: false,
                previousschoollastyear: false,
                previousschoolschoolboard: false,
                currentstandard: false,

                quota: false,
                saralid: false,
                grno: false,

                // std: false,
                // status: false,
                dataTable: null,
                localaddress: false,
                permanentaddress: false,
                photo:false,
                house: false,
                std: false,
                dataTable: null,
                div: null,
                std_id: "",
                org: "",
                exs_loader: false,
                },
                header_list: [],
            };
        },
        watch: {
            all_toggle() {
                console.log(this.all_toggle);
                var keys = Object.keys(this.field);
                // console.log("keys:"+this.field[keys[0]])
                for (let i = 0; i < keys.length; i++)
                    if (this.field[keys[i]] == false || this.field[keys[i]] == true) {
                        this.field[keys[i]] = this.all_toggle;
                    }
            },
        },
        methods: {
            ExportToExcel() {
                this.exs_loader = true;
                var htmltable = document.getElementById("my-table-id");
                var html = htmltable.outerHTML;
                window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
                this.exs_loader = false;
            },
            clear() {
                this.org_data_list = [];
            },
            getAllReport() {
                this.fetch_loader = true;
                // const data = {
                //     std: this.std_id,
                //     org: this.org.id,
                //     div: this.div,
                // };
                axios
                    .post("/Management/getAdmittedStudentReport", this.field)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_data_list = res.data.org_data;
                            this.header_list = res.data.header_list;
                            this.fetch_loader = false;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        //close loader
                        this.fetch_loader = false;
                    });
            },
            getAy() {
                const data = {
                    org: this.field.org.id,
                };
                axios
                    .post("/Management/getAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.academic_year_list = res.data.academic_year_list;
                            this.standard_list = res.data.standard_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            getStandard() {
                const data = {
                    std: this.field.std_id,
                    org: this.field.org.id,
                };
                axios
                    .post("/Management/getDiv", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.dision_list = res.data.dision_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Management/getOrg_without_all")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.org_list = res.data.org_list;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: center;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>
